import { useMemo } from 'react'

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenuItem,
} from '@/components/ui/sidebar.tsx'

import { NavButton } from '@/components/NavButton.tsx'
import { useProjectId } from '@/hooks/useProjectId.ts'

export const AnalyticsSidebar = () => {
  const projectId = useProjectId()

  const menuItems = useMemo(
    () => [
      ['Project Overview', `/project/${projectId}/analytics`],
      ['Stories Accepted', `/project/${projectId}/analytics/stories-accepted`],
      ['Story Cycle Time', `/project/${projectId}/analytics/cycle-times`],
      ['Releases Report', `/project/${projectId}/releases`],
    ],
    [projectId],
  )

  return (
    <Sidebar className="top-[60px] w-[178px]">
      <SidebarContent className="bg-tb-navy-700 px-6 py-8">
        <SidebarGroup className="px-0 py-0">
          <SidebarGroupContent className="list-none flex flex-col gap-4">
            {menuItems.map(([name, path]) => (
              <SidebarMenuItem key={name}>
                <NavButton
                  text={name}
                  path={path}
                  className="font-EN-KR-body1-regular hover:font-EN-KR-body1-bold hover:text-contents-accent"
                  activeClassName="font-EN-KR-body1-bold text-contents-onDarkPrimary"
                />
              </SidebarMenuItem>
            ))}
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}
